export * from './rateDetails.service';
import { RateDetailsService } from './rateDetails.service';
export * from './rateMap.service';
import { RateMapService } from './rateMap.service';
export * from './rates.service';
import { RatesService } from './rates.service';
export * from './values.service';
import { ValuesService } from './values.service';
export const APIS = [RateDetailsService, RateMapService, RatesService, ValuesService];
